import React from 'react';
import { Folder } from 'lucide-react';

interface CompactFolderItemProps {
  id: string;
  name: string;
  videoCount: number;
  onClick: (id: string) => void;
  isActive?: boolean;
}

export const CompactFolderItem: React.FC<CompactFolderItemProps> = ({
  id,
  name,
  videoCount,
  onClick,
  isActive = false,
}) => {
  return (
    <div
      onClick={() => onClick(id)}
      className={`group flex items-center gap-2.5 px-3 py-3 min-h-[48px] cursor-pointer transition-all duration-150 ease-out border-l-[3px] ${
        isActive ? 'border-l-[#2D6CF6]' : 'border-l-transparent hover:text-[#2D6CF6]'
      }`}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick(id);
        }
      }}
    >
      <Folder className={`w-5 h-5 flex-shrink-0 stroke-[1.5px] ${isActive ? 'text-[#2D6CF6]' : 'text-[#6B7280] group-hover:text-[#2D6CF6]'}`} />
      <div className="flex-1 min-w-0">
        <span className={`text-[14px] truncate block ${isActive ? 'text-[#2D6CF6] font-semibold' : 'text-[#374151] font-normal group-hover:text-[#2D6CF6]'}`}>
          {name}
        </span>
      </div>
      <span className={`min-w-[20px] h-[20px] flex items-center justify-center text-[10px] font-medium rounded-full border flex-shrink-0 ${
        isActive ? 'text-[#2D6CF6] border-[#2D6CF6]/30' : 'text-[#9CA3AF] border-[#E5E7EB]'
      }`}>
        {videoCount}
      </span>
    </div>
  );
};
